import { styled, VariantProps } from "@phntms/css-components";
import Link from "@itchannelplus/navigation";
import { marginVariants } from "../../../style-variants";
import styles from "./styles.module.scss";

export const ButtonContainer = styled("button", {
  css: [styles.buttonContainer, "btn"],
  variants: {
    ...marginVariants,
    size: {
      small: styles.small,
      normal: "",
    },
    variant: {
      solid: styles.solid,
      outline: "",
    },
    color: {
      light: styles.light,
      dark: styles.dark,
      primary: styles.primary,
      secondary: styles.secondary,
    },
    hideBorder: {
      true: styles.hideBorder,
    },
    width: {
      content: styles.contentWidth,
      full: styles.fullWidth,
    },
    center: {
      true: styles.center,
    },
    loading: {
      true: [styles.loading],
    },
  },
  defaultVariants: {
    size: "small",
   /* variant: "solid",
    color: "primary", */
  },
});

export const ButtonLinkContainer = styled(Link, {
  css: [styles.buttonContainer, "btn"],
  variants: {
    ...marginVariants,
    size: {
      small: styles.small,
      normal: "",
    },
    variant: {
      solid: styles.solid,
      outline: "",
    },
    color: {
      light: styles.light,
      dark: styles.dark,
      primary: styles.primary,
      secondary: styles.secondary,
    },
    hideBorder: {
      true: styles.hideBorder,
    },
    width: {
      content: styles.contentWidth,
      full: styles.fullWidth,
    },
    center: {
      true: styles.center,
    },
  },
  defaultVariants: {
    size: "small",
  },
});

export const ButtonLabel = styled("span", {
  css: styles.buttonLabel,
});

export type ButtonMarginValues = VariantProps<typeof ButtonContainer>["margin"];
